import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=10ef1f3e&scoped=true&"
import script from "./serviceList.vue?vue&type=script&lang=js&"
export * from "./serviceList.vue?vue&type=script&lang=js&"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=10ef1f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ef1f3e",
  null
  
)

export default component.exports